/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import { DEFAULT_CURRENCY } from '../locales';
import * as Permission from "../util/Permission";

export default declareEntity({
    entity: "billingRules",
    graphQL: "BillingRule",
    name: "Billing Rule",
    dynamoPrefix: 'org',
    storageType: 'central',
    writePermission: [
        Permission.PERM_EDIT_CHANNEL,
    ],
    fields: (types) => { return {
        id: {
            name: "Billing Rule ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            required: true,
            parent: true,
            filterable: true,
            hiddenCreate: true,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
        },
        flow: {
            name: "Flow",
            type: "relation",
            to: () => types['flows'],
            permission: Permission.PERM_INSTANCE_BILLING,
            //visibility: (data) => !data.flowDef,
        },
        billingNote: {
            name: "Billing note",
            type: "text",
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        validSince: {
            name: "Valid Since",
            type: "date",
        },
        validTo: {
            name: "Valid To",
            type: "date",
        },
        overridePricePerInvocation: {
            name: "Price per invocation",
            type: "number",
            permission: Permission.PERM_INSTANCE_BILLING,
            addonAfter: DEFAULT_CURRENCY,
        },
        overrideTablePerInvocation: {
            name: "Table per invocation",
            type: "string",
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        overridePricePerInstance: {
            name: "Price per instance",
            type: "number",
            permission: Permission.PERM_INSTANCE_BILLING,
            addonAfter: DEFAULT_CURRENCY,
        },
        overridePricePerInstanceNext: {
            name: "Price per instance (more)",
            type: "number",
            permission: Permission.PERM_INSTANCE_BILLING,
            addonAfter: DEFAULT_CURRENCY,
        },
        overrideMinPrice: {
            name: "Minimum Price",
            type: "number",
            permission: Permission.PERM_INSTANCE_BILLING,
            addonAfter: DEFAULT_CURRENCY,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            //visibility: (data) => !data.flow,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
